import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import { resetPasswordAuth } from '../reducers/AuthSlice';
import loginPic from '../assets/images/log.svg';
import { resetPasswordSchema } from '../validation/Validate';

const ResetPassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { token } = useParams();
    const { isLoading, error, successMessage } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            password: '',
        },
        validationSchema: resetPasswordSchema,
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setLoading(true);
            try {
                const resultAction = await dispatch(
                    resetPasswordAuth({ token, password: values.password })
                );
                if (resetPasswordAuth.fulfilled.match(resultAction)) {
                    resetForm();
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
                setSubmitting(false);
            }
        },
    });

    useEffect(() => {
        if (successMessage) {
            const timer = setTimeout(() => {
                navigate('/login');
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [successMessage, navigate]);

    return (
        <div className="containerq">
            <div className="forms-container">
                <div className="signin-signup">
                    <form className="sign-in-form" onSubmit={formik.handleSubmit}>
                        <h2 className="title">AK Boys Hostel</h2>

                        <div className="input-field">
                            <i className="fa fa-lock"></i>
                            <input
                                type="password"
                                placeholder="Enter New Password"
                                name="password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </div>
                        {formik.touched.password && formik.errors.password && (
                            <div className="error-message m-0 text-center">{formik.errors.password}</div>
                        )}

                        {error && <div className="error-message text-center">{error.message || 'Something went wrong'}</div>}
                        {successMessage && (
                            <div className="success-message text-center">{successMessage.message || 'Password reset successful'}</div>
                        )}

                        <div className="text-center d-flex justify-content-end">
                            <button
                                type="submit"
                                className="btn btn-primary text-white"
                                disabled={loading || isLoading}
                            >
                                {loading || isLoading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span> Updating...
                                    </>
                                ) : (
                                    'Reset'
                                )}
                            </button>
                        </div>
                        <Link to='/Sign-in'>Sign In</Link>
                    </form>
                </div>
            </div>

            <div className="panels-container">
                <div className="panel left-panel">
                    <img src={loginPic} className="image" alt="Login" />
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
